import type { Dispatch, FC, SetStateAction } from "react";

import { SettingsTabZboziCase } from "./settingsTabCases/SettingsTabZboziCase";
import { SettingsTabActualVisitorsCase } from "./settingsTabCases/SettingsTabActualVisitorsCase";
import { SettingsTabSummaryModalCase } from "./settingsTabCases/SettingsTabSummaryModalCase";
import { SettingsTabShoptetCouponCodeCase } from "./settingsTabCases/SettingsTabShoptetCouponCodeCase";
import { SettingsTabOrderAndRegistrationsCase } from "./settingsTabCases/SettingsTabOrderAndRegistrationsCase";

export type VariantType = "zboziCompanyRating" | "zboziProductRating";

interface NotificationSettingsTabProps {
  notificationType:
    | "zbozi"
    | "actualVisitors"
    | "summaryModal"
    | "shoptetCouponCode"
    | "orderAndRegistrations";
  selectedVariant?: "visitorSummary" | "registrationSummary" | "orderSummary";
  zboziSelectedVariant?: VariantType;
  nameOfVisitors?: string;
  text?: string;
  couponCode?: string;
  couponSale?: string;
  selectedSaleType?: string;
  couponSaleType?: string;
  setCouponSaleType?: Dispatch<SetStateAction<string>>;
  setCouponCode?: Dispatch<SetStateAction<string>>;
  setSelectedSaleType?: Dispatch<SetStateAction<string>>;
  setCouponSale?: Dispatch<SetStateAction<string>>;
  setText?: Dispatch<SetStateAction<string>>;
  setNameOfVisitors?: Dispatch<SetStateAction<string>>;
  setSelectedVariant?: Dispatch<
    SetStateAction<"visitorSummary" | "registrationSummary" | "orderSummary">
  >;
  zboziSetSelectedVariant?: Dispatch<SetStateAction<VariantType>>;
}

export const NotificationSettingsTab: FC<NotificationSettingsTabProps> = ({
  notificationType,
  selectedVariant,
  nameOfVisitors,
  text,
  zboziSelectedVariant,
  couponCode,
  couponSale,
  selectedSaleType,
  couponSaleType,
  setCouponSaleType,
  setCouponSale,
  setCouponCode,
  setSelectedSaleType,
  setText,
  setSelectedVariant,
  zboziSetSelectedVariant,
  setNameOfVisitors,
}) => {
  switch (notificationType) {
    case "zbozi":
      return (
        <SettingsTabZboziCase
          zboziSelectedVariant={zboziSelectedVariant}
          zboziSetSelectedVariant={zboziSetSelectedVariant}
        />
      );
    case "actualVisitors":
      return (
        <SettingsTabActualVisitorsCase
          nameOfVisitors={nameOfVisitors}
          setNameOfVisitors={setNameOfVisitors}
        />
      );
    case "summaryModal":
      return (
        <SettingsTabSummaryModalCase
          selectedVariant={selectedVariant}
          setSelectedVariant={setSelectedVariant}
          text={text}
          setText={setText}
        />
      );
    case "shoptetCouponCode":
      return (
        <SettingsTabShoptetCouponCodeCase
          couponCode={couponCode}
          couponSale={couponSale}
          couponSaleType={couponSaleType}
          selectedSaleType={selectedSaleType}
          setCouponCode={setCouponCode}
          setCouponSale={setCouponSale}
          setCouponSaleType={setCouponSaleType}
          setSelectedSaleType={setSelectedSaleType}
        />
      );
    case "orderAndRegistrations":
      return (
        <SettingsTabOrderAndRegistrationsCase setText={setText} text={text} />
      );
    default:
      return null;
  }
};
